import { createActionCreators} from "../utils/actionCreators";

export const {
    request: getInstitutesRequest,
    success: getInstitutesSuccess,
    failure: getInstitutesFailure
} = createActionCreators('GET_INSTITUTES');

export const {
    request: getSchoolYearsRequest,
    success: getSchoolYearsSuccess,
    failure: getSchoolYearsFailure
} = createActionCreators('GET_SCHOOLYEARS');

export const {
    request: getNextSchoolYearRequest,
    success: getNextSchoolYearSuccess,
    failure: getNextSchoolYearFailure
} = createActionCreators('GET_NEXTSCHOOLYEAR');

export const {
    request: getActualSchoolYearRequest,
    success: getActualSchoolYearSuccess,
    failure: getActualSchoolYearFailure
} = createActionCreators('GET_ACTUALSCHOOLYEAR');

export const {
    request: getPreviousSchoolYearRequest,
    success: getPreviousSchoolYearSuccess,
    failure: getPreviousSchoolYearFailure
} = createActionCreators('GET_PREVIOUSSCHOOLYEAR');

export const {
    request: getFederalStatesRequest,
    success: getFederalStatesSuccess,
    failure: getFederalStatesFailure
} = createActionCreators('GET_FEDERALSTATES');

export const {
    request: getClassificationTypesRequest,
    success: getClassificationTypesSuccess,
    failure: getClassificationTypesFailure
} = createActionCreators('GET_CLASSIFICATIONTYPES');

export const {
    request: getUsageTypesRequest,
    success: getUsageTypesSuccess,
    failure: getUsageTypesFailure
} = createActionCreators('GET_USAGETYPES');

export const {
    request: updateSchoolYearRequest,
    success: updateSchoolYearSuccess,
    failure: updateSchoolYearFailure
} = createActionCreators('UPDATE_SCHOOLYEAR');